export interface Booking {
  id: number;
  amenityId: number;
  residentId: number;
  title: string;
  titleKey?: string;
  description?: string;
  descriptionKey?: string;
  startDate: Date;
  endDate: Date;
  startTime: Date;
  endTime: Date;
  status: BookingStatus;
  createdDate: Date;
  updatedDate: Date;
  totalCost?: number;
  currency?: string;
  specialRequests?: string;
  specialRequestsKey?: string;
  recurringPattern?: RecurringPattern;
  isRecurring: boolean;
  maxParticipants?: number;
  currentParticipants: number;
}

export enum BookingStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  NO_SHOW = 'no_show',
}

export enum RecurringPattern {
  NONE = 'none',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export interface Amenity {
  id: number;
  name: string;
  nameKey?: string;
  description?: string;
  descriptionKey?: string;
  type: AmenityType;
  capacity: number;
  hourlyRate?: number;
  currency?: string;
  isActive: boolean;
  location?: string;
  locationKey?: string;
  amenities?: string[];
  bookingRules?: BookingRule[];
}

export enum AmenityType {
  POOL = 'pool',
  GYM = 'gym',
  CONFERENCE_ROOM = 'conference_room',
  PARTY_HALL = 'party_hall',
  TENNIS_COURT = 'tennis_court',
  BASKETBALL_COURT = 'basketball_court',
  LIBRARY = 'library',
  GAME_ROOM = 'game_room',
  OTHER = 'other',
}

export interface BookingRule {
  id: number;
  amenityId: number;
  ruleType: RuleType;
  value: string | number;
  isActive: boolean;
  createdDate: Date;
}

export enum RuleType {
  MAX_BOOKING_DURATION = 'max_booking_duration',
  MIN_ADVANCE_BOOKING = 'min_advance_booking',
  MAX_ADVANCE_BOOKING = 'max_advance_booking',
  ALLOWED_DAYS = 'allowed_days',
  ALLOWED_HOURS = 'allowed_hours',
  MAX_PARTICIPANTS = 'max_participants',
  CANCELLATION_POLICY = 'cancellation_policy',
}
